import { inject } from "vue";
import { PAGE_APP_SYMBOL } from "_Main/injectionSymbols";

// This is deprecated, use usePageApp in script setup instead
export default {
    setup() {
        const page = inject(PAGE_APP_SYMBOL);
        return {
            ...page
        };
    },
    created() {
        this.afterConnect({
            skipAssignModelOnLoad: this.skipAssignModelOnLoad,
            onLoaded: this.onLoaded,
            extendClientModelParameters: this.extendClientModelParameters
        });
    },
    mounted() {
        if (!this.COLSframe) return;
        // need to wait until this component is mounted so that we have a ref to the $el
        window.document.body.appendChild(this.COLSframe);
        this.showMfaPrompt();
    }
};
